module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joanne Rock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Four-time RITA nominee Joanne Rock has penned over seventy stories for Harlequin. An optimist by nature and perpetual seeker of silver linings, Joanne finds romance fits her life outlook perfectly--love is worth fighting for. A former Golden Heart recipient, she has won numerous awards for her stories. Learn more about Joanne's imaginative Muse by visiting her website "), _c('a', {
    attrs: {
      "href": "http://www.joannerock.com"
    }
  }, [_vm._v("www.joannerock.com")]), _vm._v(" or @JoanneRock6 on Twitter."), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Jkgf2G/tc-custom/9781488011559.jpg?1708053344375",
      "alt": "This image is the cover for the book Magnate's Mail-Order Bride, The McNeill Magnates"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Magnate's Mail-Order Bride, The McNeill Magnates\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A matchmaking mix-up throws a famous ballerina and a wealthy businessman into a fake engagement in this steamy romance by the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author . . .")]), _c('br'), _c('br'), _vm._v("Ballerina Sofia Koslov’s career is on the line when she’s accosted at the airport by a rich, reckless playboy—who thinks she’s his mail-order bride! But the playboy’s levelheaded brother, Quinn McNeill, solves the media snafu with a switcheroo. He’ll pretend to be her legitimate fiancé to protect her reputation—and to protect his family’s business deals from her billionaire father’s wrath."), _c('br'), _c('br'), _vm._v("Sofia’s one condition: they’ll share the spotlight as a loving couple but won’t share a bed. But soon Quinn’s gentlemanly ways strike a chord, and Sofia’s dying to renege on that condition and have a real fling . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0